import { FC } from "react";
import { Button, ConfigProvider, InputNumber } from "antd";
import { MinusOutlined, PlusOutlined } from "@ant-design/icons";

import styles from "./index.less";

import { PrimaryTheme } from "@packages/theme";
interface PayInputNumberProps {
  value?: number;
  onChange?: (value: number) => void;
  min?: number;
}

/**
 * 支付时长输入
 * @returns
 */
const PayInputNumber: FC<PayInputNumberProps> = ({
  value = 1,
  onChange,
  min = 1,
}) => {
  return (
    <ConfigProvider theme={PrimaryTheme}>
      <div className={styles.container}>
        <Button
          className={styles.btn}
          icon={<MinusOutlined className={styles.icon} />}
          onClick={() => onChange?.(value - 1)}
          disabled={value <= min}
        />
        <InputNumber
          className={styles["number-input"]}
          value={value}
          min={min}
          controls={false}
          onChange={(value) => onChange?.(value || min)}
        />
        <Button
          className={styles.btn}
          icon={<PlusOutlined className={styles.icon} />}
          onClick={() => onChange?.(value + 1)}
        />
      </div>
    </ConfigProvider>
  );
};

export default PayInputNumber;
